import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { FaCartArrowDown, FaMinusCircle, FaPlusCircle, FaSearch, FaTimes, FaBox, FaTag, FaRupeeSign, FaShoppingCart, FaPercent } from 'react-icons/fa';
import { useStateContext } from '../Context/ContextProvider';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { TextField } from '@mui/material';

function ProductsDetail() {
    const { items, setItems } = useStateContext();
    const { id } = useParams();
    const stringitems = JSON.parse(items);
    
    const [products, setProducts] = useState();
    const [norecord, setNoRecord] = useState(false);
    const [isClick, setIsClick] = useState(true);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [modalShow, setModalShow] = useState(false);
    const [completeitemprop, setCompleteItemProp] = useState([]);

    function MyVerticallyCenteredModal(props) {
        const [saleprice, setSalePrice] = useState(props.completeitem.unitsaleprice);
        const [saleqty, setSaleQty] = useState(1);
        const { items } = useStateContext();
        const stringitems = JSON.parse(items);
        const [discountpercent, setDiscountPercent] = useState(props.completeitem.extra_discount || 0);
        const [subtotaldiscount, setSubTotalDiscount] = useState(props.completeitem.extra_discount || 0);
        const [subtotal, setSubtotal] = useState(saleqty * props.completeitem.unitsaleprice);

        const handleInc = () => {
            const updateqty = parseFloat(saleqty) + 1;
            if (updateqty <= props.completeitem.qty) {
                setSaleQty(updateqty);
                setSubtotal(parseFloat(updateqty * saleprice).toFixed(2));
                setSubTotalDiscount(updateqty * props.completeitem.extra_discount);
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Not Enough Stock',
                    text: `Only ${props.completeitem.qty} items available`,
                    showConfirmButton: true,
                    confirmButtonColor: '#ff4757',
                })
            }
        }

        const handleDec = () => {
            const updateqty = parseFloat(saleqty) - 1;
            if (updateqty >= 1) {
                setSaleQty(updateqty);
                setSubtotal(parseFloat(updateqty * saleprice).toFixed(2));
                setSubTotalDiscount(updateqty * props.completeitem.extra_discount);
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Minimum Quantity',
                    text: 'Quantity cannot be less than 1',
                    showConfirmButton: true,
                    confirmButtonColor: '#f39c12',
                })
            }
        }

        const handleSubTotalDiscount = (event) => {
            const discountvalue = event.target.value;
            setDiscountPercent(discountvalue);
            setSubTotalDiscount(discountvalue);
        }

        const handleSaveModel = (e) => {
            e.preventDefault();
            if (parseFloat(saleqty) <= 0) {
                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Invalid Quantity',
                    text: 'Please enter a valid quantity',
                    showConfirmButton: true,
                    confirmButtonColor: '#f39c12',
                });
                return;
            }
            
            const remqty = {
                'remaining': props.completeitem.qty,
                'discountpercent': discountpercent,
                'subtotaldiscount': subtotaldiscount,
            }
            const newItem = { ...props.completeitem, qty: saleqty, unitsaleprice: saleprice, ...remqty };
            
            if (stringitems === null) {
                setItems([newItem]);
            } else {
                setItems([...stringitems, newItem]);
            }
            setModalShow(false);
            
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Added to Cart!',
                text: `${props.completeitem.name} x ${saleqty}`,
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
            });
        }

        const handleChangeSalePrice = (e) => {
            const val = parseFloat(e.target.value) || 0;
            setSalePrice(val);
            setSubtotal(parseFloat(saleqty * val).toFixed(2));
        }

        const handleChangeSaleQty = (e) => {
            const qty = parseFloat(e.target.value) || 0;
            if (qty <= props.completeitem.qty) {
                setSaleQty(qty);
                setSubTotalDiscount(qty * props.completeitem.extra_discount);
                setSubtotal(parseFloat(saleprice * qty).toFixed(2));
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Not Enough Stock',
                    text: `Only ${props.completeitem.qty} items available`,
                    showConfirmButton: true,
                    confirmButtonColor: '#ff4757',
                })
            }
        }

        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="product-modal"
            >
                <Modal.Header style={{ 
                    background: 'linear-gradient(135deg, #4a6cf7, #6b4cf7)',
                    color: 'white',
                    borderBottom: 'none',
                    padding: '16px 20px',
                    borderRadius: '16px 16px 0 0'
                }}>
                    <Modal.Title style={{ 
                        fontSize: '18px', 
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <FaShoppingCart /> Add to Cart
                    </Modal.Title>
                    <Button 
                        variant="link" 
                        onClick={props.onHide}
                        style={{ 
                            color: 'white', 
                            fontSize: '24px', 
                            textDecoration: 'none',
                            padding: 0,
                            margin: 0,
                            opacity: 0.8,
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}
                    >
                        <FaTimes />
                    </Button>
                </Modal.Header>
                <Modal.Body style={{ padding: '20px', background: '#f8f9fc' }}>
                    {/* Product Info */}
                    <div style={{ 
                        background: 'white',
                        borderRadius: '12px',
                        padding: '16px',
                        marginBottom: '16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                        border: '1px solid #e9ecef'
                    }}>
                        <div style={{ 
                            fontSize: '16px', 
                            fontWeight: '600', 
                            color: '#1a2332',
                            marginBottom: '6px'
                        }}>
                            {props.completeitem.name}
                        </div>
                        <div style={{ 
                            display: 'flex', 
                            gap: '20px', 
                            fontSize: '13px',
                            color: '#7a8a9e',
                            flexWrap: 'wrap'
                        }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <FaBox size={14} color="#4a6cf7" />
                                Stock: <strong style={{ color: props.completeitem.qty > 5 ? '#2ecc71' : '#ff4757' }}>
                                    {props.completeitem.qty}
                                </strong>
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <FaTag size={14} color="#4a6cf7" />
                                Price: <strong style={{ color: '#4a6cf7' }}>Rs {props.completeitem.unitsaleprice}</strong>
                            </span>
                        </div>
                    </div>

                    <form onSubmit={handleSaveModel}>
                        {/* Price & Subtotal */}
                        <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: '1fr 1fr', 
                            gap: '12px',
                            marginBottom: '12px'
                        }}>
                            <div>
                                <label style={{ 
                                    fontSize: '12px', 
                                    color: '#7a8a9e', 
                                    fontWeight: '500',
                                    display: 'block',
                                    marginBottom: '4px'
                                }}>
                                    <FaRupeeSign /> Price
                                </label>
                                <TextField
                                    fullWidth
                                    name='saleprice'
                                    value={saleprice}
                                    type='number'
                                    onChange={(e) => handleChangeSalePrice(e)}
                                    size="small"
                                    variant="outlined"
                                    InputProps={{
                                        style: { background: 'white', borderRadius: '8px' }
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{ 
                                    fontSize: '12px', 
                                    color: '#7a8a9e', 
                                    fontWeight: '500',
                                    display: 'block',
                                    marginBottom: '4px'
                                }}>
                                    Subtotal
                                </label>
                                <TextField
                                    fullWidth
                                    name='subtotal'
                                    value={subtotal}
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    InputProps={{
                                        style: { background: '#f1f3f5', borderRadius: '8px', fontWeight: '600' }
                                    }}
                                />
                            </div>
                        </div>

                        {/* Quantity & Discount */}
                        <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'auto 1fr auto 1fr',
                            gap: '8px',
                            alignItems: 'center'
                        }}>
                            <div onClick={handleDec} style={{ 
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '10px',
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <FaMinusCircle style={{ 
                                    fontSize: '36px', 
                                    color: '#f39c12',
                                    transition: 'all 0.2s ease'
                                }} />
                            </div>
                            <div>
                                <label style={{ 
                                    fontSize: '12px', 
                                    color: '#7a8a9e', 
                                    fontWeight: '500',
                                    display: 'block',
                                    marginBottom: '4px'
                                }}>
                                    Qty
                                </label>
                                <TextField
                                    fullWidth
                                    name='saleqty'
                                    value={saleqty}
                                    type='number'
                                    onChange={(e) => handleChangeSaleQty(e)}
                                    size="small"
                                    variant="outlined"
                                    InputProps={{
                                        style: { background: 'white', borderRadius: '8px' }
                                    }}
                                />
                            </div>
                            <div onClick={handleInc} style={{ 
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '10px',
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <FaPlusCircle style={{ 
                                    fontSize: '36px', 
                                    color: '#2ecc71',
                                    transition: 'all 0.2s ease'
                                }} />
                            </div>
                            <div>
                                <label style={{ 
                                    fontSize: '12px', 
                                    color: '#7a8a9e', 
                                    fontWeight: '500',
                                    display: 'block',
                                    marginBottom: '4px'
                                }}>
                                    <FaPercent /> Discount
                                </label>
                                <TextField
                                    fullWidth
                                    name='subtotaldiscount'
                                    value={subtotaldiscount}
                                    type='number'
                                    onChange={(e) => handleSubTotalDiscount(e)}
                                    size="small"
                                    variant="outlined"
                                    InputProps={{
                                        style: { background: 'white', borderRadius: '8px' }
                                    }}
                                />
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div style={{ 
                            display: 'flex', 
                            gap: '10px', 
                            marginTop: '20px',
                            justifyContent: 'flex-end'
                        }}>
                            <Button 
                                variant="outline-secondary" 
                                onClick={props.onHide}
                                style={{ 
                                    borderRadius: '10px',
                                    padding: '10px 24px',
                                    fontWeight: '500',
                                    borderColor: '#e9ecef',
                                    color: '#7a8a9e'
                                }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                type="submit"
                                style={{ 
                                    background: 'linear-gradient(135deg, #2ecc71, #27ae60)',
                                    border: 'none',
                                    borderRadius: '10px',
                                    padding: '10px 28px',
                                    fontWeight: '600',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    boxShadow: '0 4px 16px rgba(46, 204, 113, 0.3)'
                                }}
                            >
                                <FaCartArrowDown /> Add to Cart
                            </Button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        );
    }

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const clearSearch = () => {
        setSearchQuery('');
        setCurrentPage(1);
    }

    const handleSubmitCart = (id) => {
        axios.get(`/api/fetchitem/${id}`).then(res => {
            if (stringitems === null) {
                setCompleteItemProp(res.data.item);
                setModalShow(true);
            } else {
                if (stringitems.find((i) => i.id === res.data.item.id)) {
                    Swal.fire({
                        position: 'center',
                        icon: 'info',
                        title: 'Already in Cart',
                        text: 'This item has been added to your cart',
                        showConfirmButton: true,
                        confirmButtonColor: '#4a6cf7',
                    })
                } else {
                    setCompleteItemProp(res.data.item);
                    setModalShow(true);
                }
            }
        });
    }

    useEffect(() => {
        setIsClick(false);
        axios.post(`api/productdetail/${id}?page=${currentPage}&search=${searchQuery}`).then(res => {
            setProducts(res.data.data);
            setTotalPages(res.data.last_page);
            if ((res.data.data).length === 0) {
                setNoRecord(true);
            } else {
                setNoRecord(false);
            }
            setIsClick(true);
        })
    }, [id, currentPage, searchQuery])

    return (
        <div className='products-mobile'>
            <style>{`
                .products-mobile {
                    padding: 10px 10px 80px 10px;
                    background: #f5f7fa;
                    min-height: 100vh;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                }

                /* Header */
                .products-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 14px;
                }

                .products-header h2 {
                    font-size: 18px;
                    font-weight: 700;
                    color: #1a2332;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .products-header h2 svg {
                    color: #4a6cf7;
                }

                .products-count {
                    font-size: 12px;
                    color: #7a8a9e;
                    background: white;
                    padding: 4px 12px;
                    border-radius: 50px;
                    border: 1px solid #e9ecef;
                }

                /* Search */
                .search-wrapper {
                    position: relative;
                    margin-bottom: 14px;
                }

                .search-wrapper input {
                    width: 100%;
                    padding: 12px 40px 12px 44px;
                    border: 2px solid #e9ecef;
                    border-radius: 12px;
                    font-size: 15px;
                    outline: none;
                    background: white;
                    transition: all 0.3s ease;
                }

                .search-wrapper input:focus {
                    border-color: #4a6cf7;
                    box-shadow: 0 0 0 4px rgba(74, 108, 247, 0.1);
                }

                .search-wrapper input::placeholder {
                    color: #b0bec5;
                }

                .search-icon {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #7a8a9e;
                    font-size: 18px;
                }

                .search-clear {
                    position: absolute;
                    right: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: none;
                    border: none;
                    color: #7a8a9e;
                    font-size: 18px;
                    cursor: pointer;
                    padding: 4px;
                    border-radius: 50%;
                    transition: all 0.3s ease;
                }

                .search-clear:hover {
                    background: #f1f3f5;
                    color: #ff4757;
                }

                /* Product Grid */
                .product-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 10px;
                    margin-bottom: 14px;
                }

                .product-card {
                    background: white;
                    border-radius: 14px;
                    padding: 14px 12px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    border: 1px solid #e9ecef;
                    text-align: center;
                    min-height: 150px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 100%;
                    touch-action: manipulation;
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }

                .product-card:active {
                    transform: scale(0.97);
                }

                .product-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 3px;
                    background: linear-gradient(90deg, #4a6cf7, #6b4cf7);
                    opacity: 0;
                    transition: all 0.3s ease;
                }

                .product-card:hover::before {
                    opacity: 1;
                }

                .product-card-disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                .product-card-disabled:active {
                    transform: none;
                }

                .product-card-disabled::before {
                    background: #e9ecef;
                    opacity: 1;
                }

                .product-name {
                    font-size: 13px;
                    font-weight: 600;
                    color: #1a2332;
                    margin-bottom: 4px;
                    line-height: 1.3;
                }

                .product-price {
                    font-size: 14px;
                    font-weight: 700;
                    color: #4a6cf7;
                    margin-bottom: 4px;
                }

                .product-stock {
                    font-size: 12px;
                    font-weight: 600;
                    color: #ff4757;
                    margin-bottom: 8px;
                }

                .product-stock-in {
                    color: #2ecc71;
                }

                .product-btn {
                    background: linear-gradient(135deg, #4a6cf7, #6b4cf7);
                    color: white;
                    border: none;
                    border-radius: 10px;
                    padding: 10px 12px;
                    font-size: 13px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    width: 100%;
                    touch-action: manipulation;
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 8px rgba(74, 108, 247, 0.2);
                }

                .product-btn:active {
                    transform: scale(0.95);
                }

                .product-btn:disabled {
                    background: #e9ecef;
                    color: #7a8a9e;
                    cursor: not-allowed;
                    box-shadow: none;
                }

                .product-btn:disabled:active {
                    transform: none;
                }

                /* No Results */
                .no-results {
                    text-align: center;
                    padding: 60px 20px;
                    color: #7a8a9e;
                }

                .no-results svg {
                    font-size: 48px;
                    color: #e9ecef;
                    margin-bottom: 12px;
                }

                .no-results h3 {
                    color: #1a2332;
                    margin-bottom: 4px;
                }

                /* Pagination */
                .pagination-wrap {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 0;
                    background: white;
                    border-radius: 12px;
                    border: 1px solid #e9ecef;
                }

                .pagination-btn {
                    padding: 8px 16px;
                    border: none;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    touch-action: manipulation;
                    transition: all 0.3s ease;
                }

                .pagination-btn:active {
                    transform: scale(0.95);
                }

                .pagination-prev {
                    background: #f1f3f5;
                    color: #1a2332;
                }

                .pagination-prev:disabled {
                    opacity: 0.4;
                    cursor: not-allowed;
                }

                .pagination-next {
                    background: linear-gradient(135deg, #4a6cf7, #6b4cf7);
                    color: white;
                }

                .pagination-next:disabled {
                    opacity: 0.4;
                    cursor: not-allowed;
                }

                .pagination-info {
                    font-size: 13px;
                    color: #7a8a9e;
                }

                .pagination-info strong {
                    color: #1a2332;
                }

                /* Loading */
                .loading-center {
                    text-align: center;
                    padding: 60px 20px;
                    color: #7a8a9e;
                }

                .loading-spinner {
                    display: inline-block;
                    width: 40px;
                    height: 40px;
                    border: 4px solid #e9ecef;
                    border-top: 4px solid #4a6cf7;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                /* Modal - Professional */
                .product-modal .modal-content {
                    border-radius: 16px;
                    border: none;
                    overflow: hidden;
                    box-shadow: 0 20px 60px rgba(0,0,0,0.15);
                }

                .product-modal .modal-dialog {
                    margin: 1.75rem auto;
                }

                /* Mobile Responsive */
                @media (max-width: 576px) {
                    .products-mobile {
                        padding: 8px 8px 70px 8px;
                    }
                    .product-grid {
                        gap: 8px;
                    }
                    .product-card {
                        padding: 10px 8px;
                        min-height: 130px;
                    }
                    .product-name {
                        font-size: 12px;
                    }
                    .product-price {
                        font-size: 13px;
                    }
                    .product-btn {
                        font-size: 12px;
                        padding: 8px 10px;
                    }
                    .search-wrapper input {
                        font-size: 14px;
                        padding: 10px 36px 10px 40px;
                    }
                    .products-header h2 {
                        font-size: 16px;
                    }
                    .product-modal .modal-dialog {
                        margin: 0.5rem;
                    }
                    .product-modal .modal-content {
                        border-radius: 12px;
                    }
                }

                @media (max-width: 400px) {
                    .products-mobile {
                        padding: 6px 6px 60px 6px;
                    }
                    .product-grid {
                        gap: 6px;
                    }
                    .product-card {
                        padding: 8px 6px;
                        min-height: 110px;
                    }
                    .product-name {
                        font-size: 11px;
                    }
                    .product-price {
                        font-size: 12px;
                    }
                    .product-btn {
                        font-size: 11px;
                        padding: 6px 8px;
                    }
                    .pagination-wrap {
                        gap: 8px;
                        padding: 10px 0;
                    }
                    .pagination-btn {
                        font-size: 12px;
                        padding: 6px 12px;
                    }
                }

                /* Input number styling */
                input[type="number"] {
                    -moz-appearance: textfield;
                }
                input[type="number"]::-webkit-outer-spin-button,
                input[type="number"]::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                /* SweetAlert mobile optimization */
                .swal2-popup {
                    border-radius: 16px !important;
                }

                .swal2-confirm {
                    border-radius: 10px !important;
                }
            `}</style>

            {/* Header */}
            <div className="products-header">
                <h2>
                    <FaBox /> Products
                </h2>
                {products && products.length > 0 && (
                    <span className="products-count">{products.length} items</span>
                )}
            </div>

            {/* Search */}
            <div className="search-wrapper">
                <FaSearch className="search-icon" />
                <input
                    placeholder='Search products...'
                    value={searchQuery}
                    onChange={handleSearchChange}
                />
                {searchQuery && (
                    <button className="search-clear" onClick={clearSearch}>
                        <FaTimes />
                    </button>
                )}
            </div>

            {/* No Record */}
            {norecord && (
                <div className="no-results">
                    <FaBox />
                    <h3>No Products Found</h3>
                    <p>Try adjusting your search</p>
                </div>
            )}

            {/* Products */}
            {isClick ? (
                <div className="product-grid">
                    {products && products.map((item) => (
                        <div 
                            key={item.id} 
                            className={`product-card ${item.qty <= 0 ? 'product-card-disabled' : ''}`}
                            onClick={() => item.qty > 0 && handleSubmitCart(item.id)}
                        >
                            <div>
                                <div className="product-name">{item.name}</div>
                                <div className="product-price">Rs {item.unitsaleprice}</div>
                                <div className={`product-stock ${item.qty > 0 ? 'product-stock-in' : ''}`}>
                                    {item.qty > 0 ? `Stock: ${item.qty}` : 'Out of stock'}
                                </div>
                            </div>
                            <button 
                                className="product-btn"
                                disabled={item.qty <= 0}
                            >
                                <FaCartArrowDown />
                                {item.qty > 0 ? 'Add to Cart' : 'Unavailable'}
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="loading-center">
                    <div className="loading-spinner"></div>
                    <p style={{ marginTop: '10px' }}>Loading products...</p>
                </div>
            )}

            {/* Pagination */}
            {products && products.length > 0 && (
                <div className="pagination-wrap">
                    <button
                        className="pagination-btn pagination-prev"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((page) => page - 1)}
                    >
                        Previous
                    </button>
                    <span className="pagination-info">
                        <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                    </span>
                    <button
                        className="pagination-btn pagination-next"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((page) => page + 1)}
                    >
                        Next
                    </button>
                </div>
            )}

            {/* Modal */}
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                completeitem={completeitemprop}
            />
        </div>
    )
}

export default ProductsDetail